import { createInertiaApp, router } from "@inertiajs/react"
import { setNonce } from "get-nonce"

import AppLayout from "@/layouts/app-layout"
import { followPageCompany } from "@/lib/company-routes"
import { cspNonce } from "@/lib/csp"
import { showFlash } from "@/lib/toast"

// Radix dialogs and menus lock page scrolling with an injected <style> tag.
if (cspNonce) setNonce(cspNonce)

// Fires once per server response that carries flash messages, including the first page load.
router.on("flash", (event) => showFlash(event.detail.flash))
// Links to a company's pages name the page's company where its path names none (lib/company-routes).
router.on("navigate", (event) => followPageCompany(event.detail.page))

void createInertiaApp({
  title: (title) => (title ? `${title} · OrganoBooks` : "OrganoBooks"),
  strictMode: true,
  pages: "../pages",
  layout: () => AppLayout,
  // For the progress-bar styles Inertia injects.
  nonce: cspNonce,
  progress: { color: "#2f7fa3" },
  // Before the first render, which already builds links.
  withApp: (app, { page }) => {
    followPageCompany(page)
    return app
  },
  defaults: {
    form: { forceIndicesArrayFormatInFormData: false },
    // Rails reads `ids[]=1&ids[]=2` as an array.
    visitOptions: () => ({ queryStringArrayFormat: "brackets" }),
  },
})
